import Avatar from '@/components/avatar'
import Username from '@/components/username'
import { cn } from '@/util/cn'
import { IUser } from '@giphy/js-types'

const Attribution = ({
    user,
    className,
    avatarSize = 50,
}: {
    user: IUser
    className?: string
    avatarSize?: number
}) => {
    return (
        <div className={cn('group flex gap-2.5', className)}>
            <Avatar className="rounded-md" user={user} size={avatarSize} />
            <div className="flex flex-col justify-center font-semibold">
                <div>{user.display_name}</div>
                <Username noLink user={user} className="text-giphyWhite/60 group-hover:underline" />
            </div>
        </div>
    )
}

export default Attribution
